import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LanguageService, SupportedLanguage } from '../language.service';
import { environment } from '../../environments/environment';

export interface Language {
    name : string;
    code: SupportedLanguage;
    urlImg: string;
    coname: string;
    labelKey:string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatIconModule, CommonModule, ReactiveFormsModule, RouterModule, MatMenuModule, TranslateModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  readonly languages: Language[] = [
    { name: 'Italian', code: 'it-IT', urlImg: 'img/italy.png' , coname: "IT", labelKey: 'header.language.italian' },
    { name: 'English', code: 'en-US', urlImg: 'img/united-kingdom.png', coname: "EN", labelKey: 'header.language.english' },
    { name: 'Greek', code: 'el-GR', urlImg: 'img/greece.png', coname: "GR", labelKey: 'header.language.greek' },
    { name: 'French', code: 'fr-FR', urlImg: 'img/france.png', coname: "FR", labelKey: 'header.language.french' },
    { name: 'Turkish', code: 'tr-TR', urlImg: 'img/turkey.png', coname: "TR", labelKey: 'header.language.turkish' },
    { name: 'Polish', code: 'pl-PL', urlImg: 'img/poland.png', coname: "PL", labelKey: 'header.language.polish' }
  ];

  siteUrl = environment.siteUrl;

  selectedLanguage: Language;

  constructor(private readonly languageService: LanguageService) {
    this.selectedLanguage = this.languages.find(
      language => language.code === this.languageService.currentLanguage
    ) ?? this.languages[1];
  }

  changeLanguage(language: Language): void {
    this.languageService.setLanguage(language.code);
    this.selectedLanguage = language;
  }
}
